import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PostHogProvider } from '@posthog/react';
import posthog, { PostHog } from 'posthog-js';

// ── GA4 ──────────────────────────────────────────────
// const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
// if (GA_ID) {
//   const gtagScript = document.createElement('script');
//   gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
//   gtagScript.async = true;
//   document.head.appendChild(gtagScript);

//   window.dataLayer = window.dataLayer || [];
//   function gtag(...args: any[]) { window.dataLayer.push(args); }
//   window.gtag = gtag;
//   gtag('js', new Date());
//   gtag('config', GA_ID);
// }

// ── React Query ───────────────────────────────────────
const queryClient = new QueryClient();

// ── PostHog options ───────────────────────────────────
const postHogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2026-01-30',
  loaded: (ph: any) => {
    if (process.env.NODE_ENV !== 'production') {
      ph.opt_out_capturing()
    }
  },
} as const;

const rootElement = document.getElementById('root') as HTMLElement;

const app = (
  <PostHogProvider
    apiKey={process.env.REACT_APP_POSTHOG_KEY!}
    options={postHogOptions}
  >
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </PostHogProvider>
);

if (rootElement.hasChildNodes()) {
  // Pre-rendered HTML from react-snap — hydrate instead of replacing
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  // Normal client-side render (dev, or routes without a snapshot)
  ReactDOM.createRoot(rootElement).render(app);
}

reportWebVitals();